import React from "react";
import { Tabs, Badge } from 'antd';
import ColorButton from "../common/ColorButton";
import PondLatexList from "../components/pond-latex/PondLatexList";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTruck } from "@fortawesome/free-solid-svg-icons";
import { SUCCESS_COLOR } from "../constants/color";
import PondFillLatexModal from "../components/pond-latex/PondFillLatexModal";
import { GET } from "../frameworks/HttpClient";
import { URL_TRUCK } from "../constants/urls";
import ErrorMessages from "../common/ErrorMessages";
import PondLotHistoryList from "../components/pond-latex/PondLotHistoryList";
import PondRecieveLatexView from "./PondRecieveLatexView";
import { USER_GROUP } from "../constants/string";
import { useUserContext } from "../hooks/UserSettingProvider";

export default function PondLatexView() {

  const [openFillLatexModal, setOpenFillLatexModal] = React.useState(false);
  const [availableCount, setAvailableCount] = React.useState(0);
  const [errorMessages, setErrorMessages] = React.useState(null);
  const { user } = useUserContext();
  const hasPermission = (target) => (user && user.groups &&  user.groups.length > 0 ? (user.groups.find((group) => group === target) ? true : false) : true)
  const currentRef = React.useRef();
  const historyRef = React.useRef();
  
  const fetchTruckCount = async() => {
    setErrorMessages(null);
    try {
      const response = await GET(URL_TRUCK.POND_AVAILABLE_COUNT)
      setAvailableCount(response.data.count)
    } catch (error) {
      setErrorMessages(error.errorMessages)
    }
  }

  const refreshData = async() => {
    if(currentRef.current){
      await currentRef.current.fetch();
    }
    if(historyRef.current){
      await historyRef.current.fetch();
    }
  }

  const items = [
    {
      key: 'current',
      label: 'บ่อพักน้ำยางสด',
      children: <PondLatexList ref={currentRef} isDone={false} fetchTruckCount={() => fetchTruckCount()}/>,
      permissions : (hasPermission(USER_GROUP.POND) || hasPermission(USER_GROUP.RP))
    },
    {
      key: 'history',
      label: 'ประวัติล็อตน้ำยางสด',
      children: <PondLotHistoryList ref={historyRef} />,
      permissions : (hasPermission(USER_GROUP.POND) || hasPermission(USER_GROUP.RP))
    },
    {
      key: 'allTruck',
      label: 'รถเข้าโรงงาน',
      children: <PondRecieveLatexView ref={historyRef} />,
      permissions : (hasPermission(USER_GROUP.RP))
    },
  ];

  React.useEffect(() => {
    fetchTruckCount();
  },[])

  React.useEffect(() => {
    const interval = setInterval(() => {
      fetchTruckCount();
      refreshData();
    }, 300000);

    return () => clearInterval(interval);
  }, []);

  return(
    <div style={{ marginTop : 20}}>
      <ErrorMessages message={errorMessages}/>
        <Badge count={availableCount}>
          <ColorButton 
            type='primary'
            size='large'
            override={SUCCESS_COLOR}
            disabled={availableCount === 0}
            icon={ <FontAwesomeIcon icon={faTruck} />}
            onClick={()=> setOpenFillLatexModal(true)} 
          > รถรอเทน้ำยาง </ColorButton>
        </Badge>
      <Tabs
        destroyInactiveTabPane
        defaultActiveKey="current" 
        items={items.filter((item) => item.permissions == true)}
      />

      <PondFillLatexModal
        open={openFillLatexModal}
        onClose={() => setOpenFillLatexModal(false)}
        onUpdate={() => {
          setOpenFillLatexModal(false)
          refreshData();
          fetchTruckCount();
        }}
      />

    </div>
  )
}